var Listing = {
    query: null,
    holderClass: 'listing',
    updateDataElements: ['page', 'count'],
    pagerClass: '.pager',
    elem: {
        more: '.pager__load'
    },
    customCallbacks: {
        update: function(data, update) {},
        init: function() {},
        afterFetch: function() {},
        beforeFetch: function() {}
    }
};

Listing.callbacks = {
    update: function(data, update, options) {
        var $holder = $('.' + Listing.holderClass),
            $pager = $(Listing.pagerClass);

        options = options || {};

        $pager.remove();

        if (update) {
            $holder.find('.listing-fetch').replaceWith(data.html);
        } else {
            var $tempObject = $('<div />');

            $tempObject.append(data.html);
            if (!$tempObject.find('.' + Listing.holderClass).size()) {
                $tempObject.children().first().addClass(Listing.holderClass);
            }
            $holder.replaceWith($tempObject.html());
        }

        if (data.url) {
            if (!options.doNotPushHistoryState) {
                window.history.pushState({}, document.title, data.url);
            }

            if (data.model == 'Products') {
                localStorage.setItem('Rshop.lastProductListingUrl', data.url);
            }
        }

        if (window.GTMTracking) {
            window.GTMTracking.trackEvent('pageView', {
                'ecomm_prodid': data.ids,
                'ecomm_pagetype': location.pathname.indexOf('vyhladavanie') !== -1 || location.pathname.indexOf('search') !== -1 ? 'searchresults' : 'category',
                'ecomm_totalvalue': 0
            });
        }

        if (window.GA4Tracking) {
            window.GA4Tracking.trackEvent('view_item_list', {
                items: data.ids.map(function (p) {
                    return window.GA4Tracking.getProductData(p);
                })
            });
        }

        _.each(Listing.updateDataElements, function(i) {
            $('[data-element="listing"][data-type="' + i + '"]').html(data[i]);
        });

        Form.rebuildSpinners();

        this.fetchedData();
        Eshop.preloader.hide();
        Listing.customCallbacks.afterFetch();
        rEvent.dispatch('Listing.fetchedData', data);
    },
    fetchedData: function() {

    },
    popState: function() {
        var $holder = $('.' + Listing.holderClass);

        // If there is no listing on the page, do nothing
        if (!$holder.find('.listing-fetch').length) {
            return;
        }

        $.get(window.location.href, {}, function(data) {
            Listing.callbacks.update(data, false, {
                doNotPushHistoryState: true
            });
        }, 'json');
    }
};

Listing.fetchData = function(elem, options) {
    var $elem = $(elem),
        $holder = $elem.parents('.' + Listing.holderClass),
        $pager = $holder.find('.pager'),
        url = Url.removeParameter($elem.data('url'), 'page'),
        url = Url.removeParameter(url, 'start'),
        page = parseInt($elem.data('page')),
        newPage = page + 1,
        defaults = {
            async: true
        };

    if (options != undefined) {
        defaults = $.extend(defaults, options);
    }

    if (!$elem.hasAttr('data-preloader') || $elem.data('preloader')) {
        Eshop.preloader.show();
    }

    if (this.start == undefined) {
        this.start = document.URL.match(/start=([0-9]+)/) == null ? page : document.URL.match(/start=([0-9]+)/)[1];
    }

    Listing.customCallbacks.beforeFetch();

    if (defaults.fetchPage) {
        newPage = defaults.fetchPage;
    }
    var fetchData = {
        page: newPage,
        start: this.start
    };

    if (defaults.loadMore) {
        fetchData.loadMore = defaults.loadMore;
    }

    $.ajax({
        url: url,
        data: fetchData,
        dataType: 'json',
        success: function(data) {
            if (newPage == $elem.data('max') ) {
                $pager.remove();
                $elem.remove();
            } else {
                $elem.data('page', newPage);
            }

            Listing.callbacks.update(data, true);
        },
        async: defaults.async
    });
};

Listing.sendData = function(elem, postCallback) {
    var $this = this;

    if (Listing.query != null) {
        Listing.query.abort();
    }

    Eshop.preloader.show();
    Listing.customCallbacks.beforeFetch();

    var url = Url.removeParameter($(elem).attr('action'), 'page'),
        url = Url.removeParameter(url, 'start');
    $(elem).attr('action', url);

    Listing.query = Form.ajaxPost(elem, function(data) {

        if (data.url) {
            $($this.elem.more).data('url', data.url);
        }

        if (postCallback) {
            postCallback(data);
        }

        Listing.callbacks.update(data);
    }, 'json');

    return false;
}

$(function() {
    $('body').delegate('.pager__item a', 'click', function() {
        Eshop.preloader.show();
        $.get($(this).attr('href'), {}, function(data) {
            Listing.callbacks.update(data);
        }, 'json');

        return false;
    });

    var $moreButton = $('.pager .listing-more'),
        fetchPages = $moreButton.data('fetch'),
        actualPage = document.URL.match(/page=([0-9]+)/) == null ? 1 : document.URL.match(/page=([0-9]+)/)[1];

    if (fetchPages > 0) {
        for (var i = fetchPages - 1; i >= 0; i--) {
            Listing.fetchData($moreButton, {
                fetchPage: actualPage - i,
                async: false
            });
        }
    }

    $(window).on('popstate', Listing.callbacks.popState);
});
